/** UI-only drafts. No service state, permissions or commercial rules live here. */
export interface ReservationDraft {
  request_key?: string;
  request_fingerprint?: string;
  space_id: string;
  date: string;
  time: string;
  duration: string;
  people: string;
  purpose: string;
}
export const emptyReservation: ReservationDraft = {
  space_id: "",
  date: "",
  time: "",
  duration: "60",
  people: "2",
  purpose: "",
};

export function configuredValue(value: unknown): string {
  if (typeof value === "string" || typeof value === "number")
    return String(value);
  if (typeof value === "boolean") return value ? "Oui" : "Non";
  if (Array.isArray(value))
    return (
      value
        .filter((item) => typeof item === "string" || typeof item === "number")
        .join(" · ") || "À préciser"
    );
  return "Conditions détaillées à préciser";
}
export function configuredLabel(key: string): string {
  const labels: Record<string, string> = {
    price: "Prix",
    price_label: "Prix",
    billing_period: "Périodicité",
    billing_period_label: "Périodicité",
    cancellation: "Conditions d’arrêt",
    benefits: "Services inclus",
    description: "Présentation",
    conditions: "Conditions",
    network_matching: "Mises en relation",
    introductions: "Mises en relation",
  };
  return (
    labels[key] ||
    key.replace(/[_-]/g, " ").replace(/^./, (value) => value.toUpperCase())
  );
}
export function membershipLabel(
  status: string | undefined,
  signedIn: boolean,
): string {
  if (!signedIn) return "Bienvenue à vous";
  if (status === "free") return "Compte gratuit";
  if (status === "active") return "GuildCard active";
  if (status === "expired") return "Adhésion expirée";
  if (status === "suspended") return "Adhésion suspendue";
  return "Statut d’adhésion à vérifier";
}
export function subscriptionLabel(status: string | undefined): string {
  return status === "active"
    ? "Actif"
    : status === "cancelled"
      ? "Arrêté"
      : status === "past_due"
        ? "À régulariser"
        : status === "none"
          ? "Non souscrit"
          : status === "not_connected"
            ? "Non connecté"
            : "Statut à vérifier";
}
